import React from "react";
import { observer } from "mobx-react";
import { injectIntl } from "react-intl";
import Activity from "./Activity";

@injectIntl
@observer
export default class Activities extends React.Component {
  constructor(props) {
    super(props);

    this.state = {};
  }

  render() {
    const { note, intl } = this.props;

    return (
      <div className="activities-container">
        {note.activityLoading
          ? this.renderLoading()
          : note.allActivities.map(activity => (
              <Activity activity={activity} note={note} key={activity.id} />
            ))}
      </div>
    );
  }

  renderLoading = () => {
    return (
      <div className="react-board">
        <div className="loader-lg">
          <div />
        </div>
      </div>
    );
  };

  componentWillMount() {
    const { note, intl } = this.props;

    note.fetchActivities();
  }
}

Activities.propTypes = {};
